enum ReducerSliceNames{
OPEN_SEA_NFT_VALIDATOR = 'OpenSeaNftValidator',
GENERAL_INFO = 'GeneralInfo',
WALLET_INFO = 'WalletInfo',
MAIN_LAYOUT_SYSTEM = 'MainLayoutSystem',
SELECTED_NFT_DATA = 'SelectedNftData',
BRIBE = 'bribe'
}

export default ReducerSliceNames;